import { render } from "./S141072.vue?vue&type=template&id=3897a9ef"
const script = {}
script.render = render

export default script